// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1fwA7","header":"PatientBlock_header__vl3yi","label":"PatientBlock_label__3uzbO","option":"PatientBlock_option__1PGfE"};